// If we will use "small" for TitleBarComponent,
// value for MODAL_HEADER_HEIGHT will be 40, but
// we don't use it at all so leaving 48 hardcoded
export const MODAL_HEADER_HEIGHT = 48;
export const MODAL_FOOTER_HEIGHT = 68;
export const MODAL_HEIGHT_WITHOUT_CONTENT =
  MODAL_HEADER_HEIGHT + MODAL_FOOTER_HEIGHT;
export const MODAL_MAX_HEIGHT = '90vh';
